export const help = {
  'help.diagram': 'תרשים עיבוד; השלבים מתוארים גם במאמר.',
  'help.diagramLoading': 'התרשים נוצר…',
  'help.diagramFailed': 'לא ניתן להציג את התרשים. אפשר לקרוא את השלבים במאמר או את מקור התרשים להלן.',
  'help.diagramSource': 'מקור התרשים (Mermaid)',
  'help.copyContext': 'העתקת הקשר המדור לסוכן',
  'help.copyContextDetail': 'מעתיק את המדור וקישורי הכניסה הבטוחים. ללא מזהי מטופל או ביקור וללא טקסט רפואי.',
  'help.contextCopied': 'הקשר המדור הועתק.',
  'help.contextCopyFailed': 'לא ניתן להעתיק את ההקשר. נסו שוב.',
  'help.title': "עזרה",
  'help.description': "מדריך משתמש לתיעוד קליני ולקובצי המטופל.",
  'help.downloadArchive': "הורדת כל העזרה (ZIP)",
  'help.downloadingArchive': "מכין ארכיון…",
  'help.archiveFailed': "לא ניתן להוריד את הארכיון. יש לנסות שוב.",
  'help.archiveForbidden': "לחשבון שלך אין הרשאה להוריד את הארכיון.",
  'help.open': "עזרה למסך זה",
  'help.center': "פתיחת מרכז העזרה",
  'help.search': "חיפוש במדריך",
  'help.topics': "נושאים",
  'help.related': "עזרה בחלק זה",
  'help.all': "כל הנושאים",
  'help.loading': "טוען עזרה…",
  'help.failed': "לא ניתן לטעון את העזרה.",
  'help.unavailable': "נושא זה אינו זמין למרפאה או לחשבון שלך.",
  'help.retry': "ניסיון נוסף",
  'help.empty': "לא נמצאו נושאים מתאימים.",
  'help.notReady': "העזרה לעמוד זה עדיין אינה מוכנה.",
  'help.fallback': "המאמר מוצג בשפה {language}; התרגום המבוקש עדיין אינו זמין.",
  'help.internal': "פנימי — גישה מוגבלת",
  'help.contents': "בעמוד זה",
  'help.revision': "מהדורה {revision}",
  'help.language': "שפת המאמר",
} as const
